
import { defineStore } from 'pinia'

export const useTabsStore = defineStore('tabs', {
    state: () => ({
        activeTab: 'pushes'
    }),
    actions: {
        setActiveTab(tab) {
            this.activeTab = tab
        }
    }
})